var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashyLogo = function SvgCashyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0V8.94589H8.928V17.9639H18V26.982H13.464C6.02803 26.982 0 20.9419 0 13.491C0 6.04011 6.02803 0 13.464 0H18ZM18 8.94589H22.5C29.9558 8.94589 36 15.0022 36 22.4729C36 29.9437 29.9558 36 22.5 36H18V26.982H27.072V17.9639H18V8.94589Z",
    fill: "black"
  })));
};
export default SvgCashyLogo;